import { Component, OnInit, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { confirm } from 'devextreme/ui/dialog';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { Entity } from 'breeze-client';
import {
    AppInformationService,
    ArkUnitOfWork,
    AuthService,
    BreezeDxStoreService,
    UtilityService,
} from '../../core/core.module';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-base-detail',
    template: '',
    styles: [],
})
export class BaseDetailComponent implements OnInit {
    key: string;
    entity: Entity;
    rollbackOnDestroy = true;
    validationGroup = 'mainValidationGroup';
    closeRelativeUrl = '../';

    constructor(
        protected uow: ArkUnitOfWork,
        protected storeService: BreezeDxStoreService,
        protected appInfo: AppInformationService,
        protected auth: AuthService,
        protected utility: UtilityService,
        protected location: Location,
        protected route: ActivatedRoute,
        protected router: Router,
        protected modalService: BsModalService
    ) {}

    ngOnInit(): void {}

    get hasChanges() {
        return this.uow.hasChanges();
    }

    ngOnDestroy() {
        if (this.rollbackOnDestroy) this.uow.rollback();
    }

    @HostListener('window:beforeunload')
    canDeactivate() {
        return !this.hasChanges;
    }

    async beforeSave() {
        return await Promise.resolve(this.validate());
    }

    async save() {
        if (!this.hasChanges) return true;
        if (!(await this.beforeSave())) return false;
        try {
            this.appInfo.pleaseWaitShow();
            await this.uow.commit();
            await this.afterSave();
        } finally {
            this.appInfo.pleaseWaitHide();
        }
        return true;
    }

    async afterSave() {}

    navigateOnSaveNew(newKey: string, forceNavigate: boolean = false) {
        if (this.key === 'new' || forceNavigate) {
            this.key = newKey;
            this.router.navigate(['../' + newKey], {
                relativeTo: this.route,
                replaceUrl: true,
                state: { navigateOnSaveNew: true },
            });
        }
    }

    async cancel() {
        if (
            !(await confirm(
                'Are you sure you want to cancel changes?',
                'Cancel Changes'
            ))
        )
            return false;

        this.uow.rollback();
        if (!this.key || this.key === 'new') {
            this.close();
        }
        return true;
    }

    async close() {
        try {
            this.location.back();
        } catch {
            await this.router.navigate([this.closeRelativeUrl], {
                relativeTo: this.route,
            });
        }
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(
            this.validationGroup
        );
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom')
                        message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(
                    `Please fix errors before saving.\n\n${message}`,
                    'error'
                );
                return false;
            }
        }

        if (this.entity && !this.entity.entityAspect.validateEntity()) {
            const errors = this.entity.entityAspect.getValidationErrors();
            this.appInfo.notifyToast(
                errors.map((error) => error.errorMessage).join('\n')
            );
            return false;
        }

        return true;
    }
}
